<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="40" height="50" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">                
    <circle cx="20" cy="20" r="20" fill="#F2F2F2"/>
    <g clip-path="url(#clip0_547_719)">
        <path d="M15.476 15.084C16.2888 15.9273 17.2634 16.5981 18.3414 17.0562C19.4194 17.5143 20.5787 17.7502 21.75 17.75C22.9363 17.7503 24.1102 17.5087 25.2 17.04" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M14.75 17.75C14.75 19.1424 15.3031 20.4777 16.2877 21.4623C17.2723 22.4469 18.6076 23 20 23C21.3924 23 22.7277 22.4469 23.7123 21.4623C24.6969 20.4777 25.25 19.1424 25.25 17.75C25.25 16.3576 24.6969 15.0223 23.7123 14.0377C22.7277 13.0531 21.3924 12.5 20 12.5C18.6076 12.5 17.2723 13.0531 16.2877 14.0377C15.3031 15.0223 14.75 16.3576 14.75 17.75Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M26.913 28.876C26.0072 27.9646 24.9301 27.2412 23.7437 26.7476C22.5573 26.254 21.285 25.9999 20 25.9999C18.715 25.9999 17.4427 26.254 16.2563 26.7476C15.0698 27.2412 13.9928 27.9646 13.087 28.876" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8.75 20C8.75 22.9837 9.93526 25.8452 12.045 27.955C14.1548 30.0647 17.0163 31.25 20 31.25C22.9837 31.25 25.8452 30.0647 27.955 27.955C30.0647 25.8452 31.25 22.9837 31.25 20C31.25 17.0163 30.0647 14.1548 27.955 12.045C25.8452 9.93526 22.9837 8.75 20 8.75C17.0163 8.75 14.1548 9.93526 12.045 12.045C9.93526 14.1548 8.75 17.0163 8.75 20Z" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_547_719">
        <rect width="24" height="24" fill="white" transform="translate(8 8)"/>
        </clipPath>
    </defs>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
